import { http } from '../helpers/http'

/**
 * Login the user using the arcgis oAuth access token & username
 * @param {Object} credentials
 * @returns {Promise} Axios promise
 */
const setOAuthCredentials = credentials => {
  return http.post('/auth-tokens', credentials)
    .then(user => {
      window.localStorage.setItem('auth', JSON.stringify(user.data))
      return user.data
    })
}

/**
 * Logout the user, destroy token in window.localStorage and send a request to invalidate that token server-side
 * @returns {Promise} Axios promise
 */
const logout = () => {
  const user = JSON.parse(window.localStorage.getItem('auth'))
  if (user) {
    const headers = { 'X-Auth-Token': user.value }
    return http.delete(`/auth-token/${user.value}`, { headers })
      .finally(() => {
        window.localStorage.removeItem('auth')
        window.localStorage.removeItem('oauth-credentials')
      })
  }

  return Promise.resolve()
}

export const authenticationService = {
  logout,
  setOAuthCredentials
}
